export default [
  {
    path: '/shaanxi/index', // 陕西和生活首页 微医医疗服务
    name: 'SHAANXIINDEX',
    component: () => import('@/views/shaanxi/index'),
    meta: {
      title: '微医医疗服务'
    }
  },
  {
    path: '/shaanxi/my', // 我的
    name: 'SHAANXIMY',
    component: () => import('@/views/shaanxi/my'),
    meta: {
      title: '微医医疗服务'
    }
  },
  {
    path: '/shaanxi/member', // 会员套餐开通
    name: 'MEMBER',
    component: () => import('@/views/shaanxi/member'),
    meta: {
      title: '微医医疗服务'
    }
  },
  {
    path: '/shaanxi/buy', // 微医健康通订购
    name: 'BUY',
    component: () => import('@/views/shaanxi/buy'),
    meta: {
      title: '微医医疗服务'
    }
  },
  {
    path: '/shaanxi/succeed', // 和生活订购成功 页面
    name: 'SUCCEED',
    component: () => import('@/views/shaanxi/succeed'),
    meta: {
      title: '开通成功'
    }
  },
  {
    path: '/aggregate/ajwy', // 安家无忧
    name: 'AJWY',
    component: () => import('@/views/aggregate/ajwy'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/aggregate/single-benefits', // 单权益聚合页
    name: 'SINGLEBENEFITS',
    component: () => import('@/views/aggregate/single-benefits'),
    meta: {
      title: '微医医疗服务'
    }
  },
  {
    path: '/gdzlyx/meal', // 广东直连粤享5G健康守护方案-健康守护套餐介绍页
    name: 'GDZLYXMEAL',
    component: () => import('@/views/gdzlyx/meal'),
    meta: {
      loginNo: true,
      keepAlive: true
    }
  },
  {
    path: '/yundong/meal', // 云栋
    name: 'YDMEAL',
    component: () => import('@/views/gdzlyx/yundong-meal'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/gdzlyx/couponIndex',  //  线下门店优惠券(介绍页)
    name: 'GDZLYXCOUPONINDEX',
    meta: {
      title: '药品优惠券'
    },
    component: () => import('@/views/gdzlyx/memberCenter/couponIndex')
  },
  {
    path: '/gdzlyx/couponReceived',  //  线下门店优惠券(已领取)
    name: 'GDZLYXCOUPONRECEIVED',
    meta: {
      title: '药品优惠券'
    },
    component: () => import('@/views/gdzlyx/memberCenter/couponReceived')
  },
  {
    path: '/gdzlyx/couponList',  //  线下门店优惠券列表
    name: 'COUPONLIST',
    meta: {
      title: '药品优惠券'
    },
    component: () => import('@/views/gdzlyx/memberCenter/couponList')
  },
  {
    path: '/familyDoctor/index', // 家庭医生
    name: 'DOCTORINDEX',
    component: () => import('@/views/familyDoctor/index'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/familyDoctor/orderedButNotSigned', // 家庭医生列表
    name: 'ORDERedbutnotsigned',
    component: () => import('@/views/familyDoctor/orderedButNotSigned'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/familyDoctor/teamDetail', // 家庭医生详情
    name: 'TEAMDETAIL',
    component: () => import('@/views/familyDoctor/teamDetail'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/familyDoctor/serviceAgreement', // 服务协议
    name: 'SERVICEAGREEMENT',
    component: () => import('@/views/familyDoctor/serviceAgreement'),
    meta: {
      loginNo: true
    }
  },
  {
    path: '/aggregate/serve',
    name: 'SERVE',
    component: () => import('@/views/aggregate/serve'),
    meta: {
      title: '全部服务'
    }
  },
  {
    path: '/equity/quickConsultation',
    name: 'QUICKCOUSULTATION',
    component: () => import('@/views/equity/quickConsultation'),
    meta: {
      title: '快速问诊'
    }
  },
  {
    path: '/equity/register',
    name: 'QUICKCOUSULTATION',
    component: () => import('@/views/equity/register'),
    meta: {
      title: '预约挂号'
    }
  },
  {
    path: '/payment/product/:code/:id',
    name: 'PAYMENTPTODUCT',
    component: () => import('@/views/payment/product'),
    meta: {
      title: '推荐会员详情'
    }
  },
  {
    path: '/healthGold/index',
    name: 'HEALTHGOLDINDEX',
    component: () => import('@/views/healthGold/index'),
    meta: {
      title: '健康金'
    }
  },
  {
    path: '/healthGold/rules',
    name: 'HEALTHGOLDRULES',
    component: () => import('@/views/healthGold/rules'),
    meta: {
      title: '健康金规则'
    }
  },
  {
    path: '/healthGold/record',
    name: 'HEALTHGOLDRECORD',
    component: () => import('@/views/healthGold/record'),
    meta: {
      title: '健康金记录'
    }
  },
  {
    path: '/healthGold/invite',
    name: 'HEALTHGOLDINVITE',
    component: () => import('@/views/healthGold/invite'),
    meta: {
      title: '邀请您成为一敦健康用户'
    }
  },
  {
    path: '/healthGold/inviteShare',
    name: 'HEALTHGOLDINVITESHARE',
    component: () => import('@/views/healthGold/inviteShare'),
    meta: {
      title: '邀请您成为一敦健康用户'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/aggregate.js